import styled from 'styled-components';

const FooterWrapper = styled.div`
    // position: fixed;
    width: 100%;
    bottom: 0;
    
    .footer{
        width: 100%;
        background: rgba(40, 108, 77,0.12);
        padding: 40px 60px;
        margin:0;
        .social{
            display:flex;
            // align-items: center;
            justify-content: space-between;
            width: 15vw;
            & > a{
                color:transparent;
                & > svg{
                    width: 2vw
                }
            }
        }
        .stores{
            display:flex;
            align-items: center;
            justify-content: space-between;
            // margin-left:10px;
            align-items: baseline;
            width: 11vw;
            & > a{
                color:transparent;
                & > svg{
                    width: 7vw;
                }
            }
           
        }
        .social-responsive{
            display:flex;
            align-items: center;
            justify-content: space-between;

            width: 35vw;
            min-width: 200px;
            & > a{
                color:transparent;
                & > svg{
                    width: 10vw;
                    max-width: 30px;
                }
            }
        }
        .stores-responsive{
            display:flex;
            align-items: center;
            justify-content: space-between;
            margin-Bottom:20px;
            align-items: baseline;
            width: 30vw;
            min-width: 150px;
            & > a{
                color:transparent;
                & > svg{
                    width: 30vw;
                    max-width: 90px;
                }
            }
           
        }
        .navigation-menu{
            & a{

                font-size:15px;
                text-decoration:none;
                color: var(--main-color);
                font-family:'kufi-regular';
                margin-bottom:10px;
            }
       
        }
    }
  
    .copywirte{
        background: #036822;
        color: white;
        text-align: center;
        padding: 10px;
    }
`;
export default FooterWrapper;